import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useMutation, useQueryClient } from 'react-query';
import { removeEmployeeNote } from 'RestAPIs/employees/notes';

const useRemoveEmployeeNote = () => {
  const queryClient = useQueryClient();

  return useMutation((noteId: number) => removeEmployeeNote(noteId), {
    onSuccess: () => {
      queryClient.invalidateQueries('employeeNotes');
      showSuccessSnackbar();
    },
    onError: (error) => {
      console.error('Error removing note:', error);
      showErrorSnackbar();
    }
  });
};

export default useRemoveEmployeeNote;
